module.exports = function (app) {
	'use strict';

	app.controller('pages.employee.cancelCoverage', ['$state', '$scope', '$filter', 'services', 'modal', 'sessionData', 'employee', 'planAdmin', 'coverageBuddy','coremetrics','$timeout','$rootScope','storage',
		function ($state, $scope, $filter, services, modal, sessionData, employee, planAdmin, coverageBuddy,coremetrics,$timeout, $rootScope,storage) {

			var UMI;
			if ($state && $state.params && $state.params.umi) {
				//to retain the state params on refresh of the page
				UMI=$state.params.umi;
				storage.set('thisUmi', $state.params.umi);
			} else if (storage.get("thisUmi")) {
				UMI=storage.get("thisUmi")
			}
			/**
			* Creates a base cancellation object based on employee/dependents, so that
			* we don't get any undefined errors in data modelling in our template
			*/
            if(sessionData.appConfig && sessionData.appConfig.SEP) {
                $scope.hasSEP = sessionData.appConfig.SEP.booleanValue;
					//sessionData.appConfig.SEP.booleanValue;
            }
            else {
                $scope.hasSEP = false;
            }
            $scope.outSideOpen = false;
			var coverageEffectivePins = [];
            var normalizeOutgoingDate = function(date) {
                return $filter('date')(date, 'MM/dd/yyyy');
                
            };
            if($scope.hasSEP) {
                services.eprsvc.lifeEventRules().checkOpenEnrollment().then(
                function (response) {
					if (response) {
					$scope.outSideOpen = response;
				}
				});
                $scope.lifeEventValues = services.eprsvc.lifeEventRules().getLifeEventRules().then(
                    function (response) {
                        if (response && response.data && response.data.payload) {
                            $scope.lifeEventValues = response.data.payload;
                        }
                    }
                );
            }

            $scope.isChrome = ((navigator.userAgent.toLowerCase().indexOf('chrome') > -1) &&(navigator.vendor.toLowerCase().indexOf("google") > -1));
            $scope.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            $scope.showSEP= false;
            $scope.lifeEventReason = '';
            $scope.lifeEventDate = '';
            $scope.cancelDate = '';
            $scope.minSepMessage = 'Please make sure that the entered cancel date is equal or greater than the coverage effective date. Please update and try again.';
            $scope.futureCancelledDates = [];
            $scope.futureCancelledGroups = [];
			$scope.initializeCancelObject = function(initialValue) {
				var coverages = {
					editable: [],
					viewOnly: []
				};

                var p = coverageBuddy.getActiveGroupNumbers(employee.data.subscriber);
                getWarningMessage(p);
                $timeout(function () {
                    if($scope.futureCancelledDates.length > 0){
                      var futureActive = coverageBuddy.getFutureActiveGroupNumbers(employee.data.subscriber);
                        if($scope.futureCancelledDates.length === 1){
                        	if(futureActive.length > 0){
                        		var singleFutureActive = false;
                        		if(futureActive.length === 1 && futureActive[0] === $scope.futureCancelledGroups[0]){
                                    singleFutureActive = true;
								}
								if(singleFutureActive === true){
                                    coverageBuddy.showCoverageModal('cancelCoverageNotice', $rootScope.$new(), { cancelDate: $scope.futureCancelledDates, groupNumber: $scope.futureCancelledGroups });
                                }
                                else {
                                    coverageBuddy.showCoverageModal('cancelCoverageUpcomingNotice', $rootScope.$new(), {
                                        cancelDate: $scope.futureCancelledDates, groupNumber: $scope.futureCancelledGroups});

                                    }

							}
							else {
                        		coverageBuddy.showCoverageModal('cancelCoverageNotice', $rootScope.$new(), { cancelDate: $scope.futureCancelledDates, groupNumber: $scope.futureCancelledGroups });
                            }
                        	}
                        else if($scope.futureCancelledDates.length === 2){
                            coverageBuddy.showCoverageModal('cancelCoverageMulti', $rootScope.$new(), { cancelDate: $scope.futureCancelledDates , groupNumber : $scope.futureCancelledGroups });

                        }
                    else {
                            coverageBuddy.showCoverageModal('cancelCoverageMultiMess', $rootScope.$new(), { cancelDate: $scope.futureCancelledDates , groupNumber : $scope.futureCancelledGroups });

                        }

                    }
                });




				var setMembersCancelObject = function(person, covIndex, plan, member) {
					var addedAtLeastOneCoverage;

					for (var i = 0; i < person.memberCoverages[covIndex].memberLobs.length; ++i) {
						if (
							!person.memberCoverages[covIndex].memberLobs[i].coverageEndDate ||
							new Date(person.memberCoverages[covIndex].memberLobs[i].coverageEndDate) > new Date()
						) {
							var lineOfBusiness = person.memberCoverages[covIndex].memberLobs[i].lineOfBusiness;
							plan.coverages[lineOfBusiness] = initialValue || false;
							addedAtLeastOneCoverage = true;
						}
					}
					if (addedAtLeastOneCoverage) {
						if (member.memberType === 'subscriber') {
							if (planAdmin.canModifyGroupNumber(plan.groupNumber)) {
								coverages.editable.push($scope.subscriber.memberCoverages[covIndex].groupNumber);
							}
							if (planAdmin.canOnlyViewGroupNumber(plan.groupNumber)) {
								coverages.viewOnly.push($scope.subscriber.memberCoverages[covIndex].groupNumber);
							}
						}
						if (planAdmin.canModifyGroupNumber(plan.groupNumber)) {
							member.plans.push(plan);
						}
						if (planAdmin.canOnlyViewGroupNumber(plan.groupNumber)) {
							member.viewOnlyPlans.push(plan);
						}
					}
				};

				var members = [];

				(function setSubscriber() {
					var member = {
						name: $scope.subscriber.fullName.first + ' ' + $scope.subscriber.fullName.last,
						memberType: 'subscriber',
						relationshipCode: $scope.subscriber.relationshipCode,
						birthDate: $scope.subscriber.birthDate,
						ssn: $scope.subscriber.ssn,
						plans: [],
						viewOnlyPlans: []
					};
					$scope.subscriber.memberCoverages.forEach(function(group, g) {
						var plan = {
							groupNumber: group.groupNumber,
							coverages: {},
							pin: $scope.subscriber.pin
						};
						setMembersCancelObject($scope.subscriber, g, plan, member);
					});
					members.push(member);
				}());

				(function setDependents() {
					var relationshipCodeMap = {
						'20': 'subscriber',
						'01': 'spouse',
						'02': 'dependent',
						'29': 'domesticPartner'
					};
					$scope.dependents.forEach(function(dependent) {
						var	member = {
							name: dependent.fullName.first + ' ' + dependent.fullName.last,
							pin: dependent.pin,
							relationshipCode: dependent.relationshipCode,
							memberType: relationshipCodeMap[dependent.relationshipCode],
							birthDate: dependent.birthDate,
							ssn: dependent.ssn,
							plans: [],
							viewOnlyPlans: []
						};
						dependent.memberCoverages.forEach(function(g, i) {
							var plan = {
								groupNumber: g.groupNumber,
								coverages: {},
								pin: dependent.pin
							};
							setMembersCancelObject(dependent, i, plan, member);
						});
						members.push(member);
					});
				}());

				$scope.categoryCodeMap = (function createInitialCodeMap(m) {
					members.forEach(function(member) {
						member.plans.forEach(function(plan) {
							var groupNumber = plan.groupNumber;
							m[groupNumber] = m[groupNumber] || {};

							Object.keys(plan.coverages).forEach(function(coverage) {
								m[groupNumber][coverage] = m[groupNumber][coverage] || {
									subscriber: 0,
									spouse: 0,
									domesticPartner: 0,
									parasites: 0
								};

								var l = m[groupNumber][coverage];
								switch (member.relationshipCode) {
									case '20': ++l.subscriber;
										break;
									case '01': ++l.spouse;
										break;
									case '29': ++l.domesticPartner;
										break;
									default: ++l.parasites;
								}
							});
						});
					});

					return m;
				}({}));

				$scope.cancellationRequests = members;
				$scope.planHeaders = coverages.editable.concat(coverages.viewOnly);

				$scope.$watch('cancellationRequests', function(n) {
					if (n && Array.isArray(n)) {
						var coverageEffectiveDates = [];
                        coverageEffectivePins = [];

						n.forEach(function(member) {
							member.plans.forEach(function(plan) {
								Object.keys(plan.coverages).filter(
									function(k) {
										return Boolean(plan.coverages[k]);
									}
								).forEach(function(lineOfBusiness) {
									var participant = employee.getParticipantByPIN(plan.pin, $scope.coverageSummary.data);
									var coverage = coverageBuddy.getCoveragesByGroupNumber(participant, plan.groupNumber)[0];
									var fullLOB = coverage.memberLobs.filter(function(l) {
										return l.lineOfBusiness ===  lineOfBusiness;
									})[0];

									coverageEffectiveDates.push(fullLOB.coverageEffectiveDate);
                                    coverageEffectivePins.push(participant.pin);
								});
							});
						});

						$scope.latestSelectedEffectiveDate = coverageEffectiveDates.reduce(function(p, n) {
							return +p > +n ? p : n;
						}, 0);
                        if(coverageEffectiveDates.length > 0){
                            $scope.showSEP = true;
                        }
                        else{
                            $scope.showSEP = false;
                        }
					}
				}, true);
			};

            var isValid = function(form) {
                form.$setSubmitted();
                return form.$valid;
            };


                $scope.$watch('cancelDate', function (n) {
                	if(n instanceof Date) {
                        if ($scope.cancelDate instanceof Date) {
                            if ($scope.cancelDate < $scope.latestSelectedEffectiveDate) {
                                $scope.minErrorMessage = $scope.latestSelectedEffectiveDate;
                            }
                        }
                        if ($scope.lifeEventReason && $scope.lifeEventDate instanceof Date) {
                            $scope.beforeDate = new Date($scope.lifeEventDate.getFullYear(), $scope.lifeEventDate.getMonth(), $scope.lifeEventDate.getDate() - parseInt($scope.lifeEventReason.beforeDays));
                            if (truncateToDay($scope.beforeDate) > truncateToDay($scope.latestSelectedEffectiveDate)) {
                                $scope.minSepMessage = 'The Life Event Date given is outside the allowable Special Enrollment Period.  To proceed, please verify the date entered or contact your BCBSWY Agent at BCBSWY.com/insurance.';
                                $scope.minErrorMessage = $scope.beforeDate;

                            }
                            else {
                                if ($scope.cancelDate instanceof Date) {
                                    if (truncateToDay($scope.cancelDate) < truncateToDay($scope.latestSelectedEffectiveDate)) {
                                    	$scope.minErrorMessage = $scope.latestSelectedEffectiveDate;
                                    }
                                }
                            }
                            $scope.afterDateSep = new Date($scope.lifeEventDate.getFullYear(), $scope.lifeEventDate.getMonth(), $scope.lifeEventDate.getDate() + parseInt($scope.lifeEventReason.afterDays));
                        }
                    }
                }, true);
                $scope.$watch('lifeEventReason', function (n) {
                    if ($scope.lifeEventDate instanceof Date) {
                        $scope.beforeDate = new Date($scope.lifeEventDate.getFullYear(), $scope.lifeEventDate.getMonth(), $scope.lifeEventDate.getDate() - parseInt($scope.lifeEventReason.beforeDays));
                        if (truncateToDay($scope.beforeDate) > truncateToDay($scope.latestSelectedEffectiveDate)) {
                            $scope.minSepMessage = 'The Life Event Date given is outside the allowable Special Enrollment Period.  To proceed, please verify the date entered or contact your BCBSWY Agent at BCBSWY.com/insurance.';
                            $scope.minErrorMessage = $scope.beforeDate;

                        }
                        else{
                            if ($scope.cancelDate instanceof Date) {
                                if (truncateToDay($scope.cancelDate) < truncateToDay($scope.latestSelectedEffectiveDate)) {
                                    $scope.minErrorMessage = $scope.latestSelectedEffectiveDate;
                                }
                            }
						}
                        $scope.afterDateSep = new Date($scope.lifeEventDate.getFullYear(), $scope.lifeEventDate.getMonth(), $scope.lifeEventDate.getDate() + parseInt($scope.lifeEventReason.afterDays));
                    }
                }, true);
                $scope.$watch('lifeEventDate', function (n) {
                    if(n instanceof Date) {
                        if ($scope.lifeEventReason && $scope.lifeEventDate instanceof Date) {
                            $scope.beforeDate = new Date($scope.lifeEventDate.getFullYear(), $scope.lifeEventDate.getMonth(), $scope.lifeEventDate.getDate() - parseInt($scope.lifeEventReason.beforeDays));
                            if (truncateToDay($scope.beforeDate) > truncateToDay($scope.latestSelectedEffectiveDate)) {
                                $scope.minSepMessage = 'The Life Event Date given is outside the allowable Special Enrollment Period.  To proceed, please verify the date entered or contact your BCBSWY Agent at BCBSWY.com/insurance.';
                                $scope.minErrorMessage = $scope.beforeDate;

                            }
                            else {
                                if ($scope.cancelDate instanceof Date) {
                                    if (truncateToDay($scope.cancelDate) < truncateToDay($scope.latestSelectedEffectiveDate)) {
                                    	$scope.minErrorMessage = $scope.latestSelectedEffectiveDate;
                                    }
                                }
                            }
                            $scope.afterDateSep = new Date($scope.lifeEventDate.getFullYear(), $scope.lifeEventDate.getMonth(), $scope.lifeEventDate.getDate() + parseInt($scope.lifeEventReason.afterDays));
                        }
                    }
                }, true);




			/**
			* Cascades checking (but not unchecking) a parent employees cancellation to dependents' boxes
			*/
			$scope.cascadeSelection = function(memberType, groupNumber, key, coverages) {

                if (sessionData.employerInfo.brandName === '6012' || sessionData.employerInfo.brandName === '9017'|| sessionData.employerInfo.brandName === '9018') {
			
					if (coverageBuddy.coverageTypeMap.medical.indexOf(key) > -1 && !$scope.isMemberSubscriber(memberType) ||( (coverageBuddy.coverageTypeMap.drug.indexOf(key) > -1 && !$scope.isMemberSubscriber(memberType)) && (sessionData.employerInfo.brandName === '9017'|| sessionData.employerInfo.brandName === '9018'))) {
					
                        if (Object.keys(coverages).length > 1) {
                            Object.keys(coverages).forEach(function (p1) {							
								if((key==="PPO" || key==="POS"|| key==="MM" || key==="PDG") && (sessionData.employerInfo.brandName === '9017'|| sessionData.employerInfo.brandName === '9018'))
										{
											if(coverages[key]===true )
											{
												switch (p1) {
													case 'VIS':
														coverages[p1] = true;	
														break;	
													case 'PDG':
														coverages[p1] = true;	
														break;
													case 'PPO':
														coverages[p1]= true;	
														break;
													case 'POS':
													    coverages[p1]= true;	
														break;
												}
													
											}
											else
											{
												switch (p1) {
													case 'VIS':
														coverages[p1] = false;	
														break;	
													case 'PDG':
														coverages[p1] = false;	
														break;
													case 'PPO':
														coverages[p1] = false;
														break;
													case 'POS':
														coverages[p1] = false;
														break;
												}												
											}
											
										}else{
											if(sessionData.employerInfo.brandName === '6012')
											{
													if (coverages[key] === true) {
														coverages[p1] = true;
													} else if (coverages[key] === false) {
														coverages[p1] = false;
													}
										    }
						      	}
                            });
                        }
                    }
                    if ($scope.isMemberSubscriber(memberType)) {
				
                        for (var member in $scope.cancellationRequests) {
                            var memberObj = $scope.cancellationRequests[member];
                            for (var plan in memberObj.plans) {
                                var planObj = memberObj.plans[plan];
                                if (planObj.groupNumber === groupNumber) {
                                    Object.keys(planObj.coverages).forEach(function (cove) {
									
										if((key==="POS" || key==="PPO"|| key==="MM" || key==="PDG") && (sessionData.employerInfo.brandName === '9017'|| sessionData.employerInfo.brandName === '9018'))
										{
											if(coverages[key]===true )
											{
												switch (cove) {
													case 'VIS':
														planObj.coverages[cove] = true;	
														break;	
													case 'PDG':
														planObj.coverages[cove] = true;	
														break;
													case 'PPO':
														planObj.coverages[cove] = true;	
														break;
													case 'POS':
														planObj.coverages[cove] = true;	
														break;
												}
													
											}
											else
											{
												switch (cove) {
													case 'VIS':
														coverages[cove] = false;	
														break;	
													case 'PDG':
														coverages[cove] = false;	
														break;
													case 'PPO':
														coverages[cove] = false;
														break;
													case 'POS':
														coverages[cove] = false;	
														break;
												}												
											}
											
										} else{
											if(sessionData.employerInfo.brandName === '6012')
											{
											if (coverages[key] === true) {
												planObj.coverages[cove] = true;
											}
											else if (coverages[key] === false) {
												coverages[cove] = false;
											}
										}
										}
                                       

                                    });

                                }
                            }
                        }
                    }
                } else {
				
                var checkMultipleMedical = function (coverages) {
                    var count = 0;
                    if (Object.keys(coverages).length > 1) {
                        Object.keys(coverages).forEach(function (p1) {
                            if (coverageBuddy.coverageTypeMap.medical.indexOf(p1) > -1) {
                                count = count + 1;
                            }
                        });
                    }
                    return count > 1 ? false : true;

                };
                if ((coverageBuddy.coverageTypeMap.drug.indexOf(key) > -1 || coverageBuddy.coverageTypeMap.medical.indexOf(key) > -1) && checkMultipleMedical(coverages)) {
                    if (Object.keys(coverages).length > 1) {
                        if (coverageBuddy.coverageTypeMap.drug.indexOf(key) > -1) {
                            Object.keys(coverages).forEach(function (p1) {
                                if (coverageBuddy.coverageTypeMap.medical.indexOf(p1) > -1) {
                                    if (coverages[key] === true) {
                                        coverages[p1] = true;
                                    } else if (coverages[key] === false) {
                                        coverages[p1] = false;
                                    }
                                }
                            });

                        }
                        if (coverageBuddy.coverageTypeMap.medical.indexOf(key) > -1) {
                            Object.keys(coverages).forEach(function (p1) {
                                if (coverageBuddy.coverageTypeMap.drug.indexOf(p1) > -1) {
                                    if (coverages[key] === true) {
                                        coverages[p1] = true;
                                    } else if (coverages[key] === false) {
                                        coverages[p1] = false;
                                    }
                                }
                            });
                        }
                        //});
                    }

                }

                if ($scope.isMemberSubscriber(memberType) && coverages[key]) {
                    for (var member in $scope.cancellationRequests) {
                        var memberObj = $scope.cancellationRequests[member];
                        for (var plan in memberObj.plans) {
                            var planObj = memberObj.plans[plan];
                            if (planObj.groupNumber === groupNumber) {
                                Object.keys(planObj.coverages).forEach(function (p1) {
                                    if (planObj.coverages.hasOwnProperty(key)) {
                                        planObj.coverages[key] = true;
                                    }
                                    if ((coverageBuddy.coverageTypeMap.drug.indexOf(key) > -1 || coverageBuddy.coverageTypeMap.medical.indexOf(key) > -1) && checkMultipleMedical(coverages)) {
                                        if (coverageBuddy.coverageTypeMap.drug.indexOf(p1) > -1) {
                                            if (planObj.coverages.hasOwnProperty(p1)) {
                                                planObj.coverages[p1] = true;

                                            }
                                        }
                                        if (coverageBuddy.coverageTypeMap.medical.indexOf(p1) > -1) {
                                            if (planObj.coverages.hasOwnProperty(p1)) {
                                                planObj.coverages[p1] = true;


                                            }
                                        }
                                    }

                                });

                            }
                        }
                    }
                }
            }
			};



			/**
			* Checks all boxes for a person, unless they're all already checked, then this unchecks all boxes that are
			* able to be validly unchecked
			*/
			$scope.checkAllPersonsBoxes = function(member) {
				var checkedAtLeastOneBox = false;
				var isMainSubscriber = $scope.isMemberSubscriber(member.memberType);

				var checkAllBoxesWithValueOf = function(value) {
					for (var plan in member.plans) {
						var currentPlan = member.plans[plan];
						for (var coverage in currentPlan.coverages) {
							if (isMainSubscriber || !$scope.isMainSubscriberCoverageChecked(plan, coverage)) {
								if (currentPlan.coverages[coverage] === false) {
									checkedAtLeastOneBox = true;
								}
								currentPlan.coverages[coverage] = value;
							}
						}
					}
				};

				checkAllBoxesWithValueOf(true);
				if (!checkedAtLeastOneBox) {
					checkAllBoxesWithValueOf(false);
				}
				else if (isMainSubscriber) {
					$scope.initializeCancelObject(true);
				}
			};

			$scope.isMainSubscriberCoverageChecked = function(planIndex, coverageKey) {
				return $scope.cancellationRequests[0].plans[planIndex].coverages[coverageKey];
			};

			/**
			* Checks all boxes for a plan, unless they're all already checked, then this unchecks all boxes
			*/
			$scope.checkAllPlansBoxes = function(planIndex) {
				var checkedAtLeastOneBox = false;
				var checkAllBoxesWithValueOf = function(value) {
                    for (var y = 0; y < $scope.cancellationRequests.length; y++) {
                        if ($scope.cancellationRequests[y].plans.length < 1) {
                            $scope.cancellationRequests.splice(y, 1);
                        }
                    }
					for (var member in $scope.cancellationRequests) {
						for (var coverage in $scope.cancellationRequests[member].plans[planIndex].coverages) {
                            if ($scope.cancellationRequests[member].plans[planIndex].coverages[coverage] === false) {
                                checkedAtLeastOneBox = true;
                            }
                            $scope.cancellationRequests[member].plans[planIndex].coverages[coverage] = value;
                        }

					}
				};

				checkAllBoxesWithValueOf(true);
				if (!checkedAtLeastOneBox) {
						checkAllBoxesWithValueOf(false);
				}
			};



			var setCancelModalContent = function(header, message) {
				$scope.modalTitle = header;
				$scope.cancelSuccessModalMessage = message;
			};

			var showModal = function() {
				$scope.employee.metadata.submissionInProgress = false;
				if(($scope.modalTitle !== '' || $scope.modalTitle !== null) && window.location.href.indexOf('/manage-employees/cancel-coverage') !== -1) {
                    modal.open({
                                   template: require("pages/employee/modals/cancelSuccessModal.html"),
                                   scope: $scope
                               });
                }
			};

			var showErrorModal = function() {
				$scope.employee.metadata.submissionInProgress = false;
				setCancelModalContent("Error", "Selected coverage was unable to be cancelled.");
				showModal();
			};

			var showGenericModal = function(content) {
				$scope.employee.metadata.submissionInProgress = false;
				$scope.modalContent = {
					header: content.header,
					message: content.message
				};
				modal.open({
					template: require("pages/employee/modals/genericInfoModal.html"),
					scope: $scope
				});
			};

            $scope.isComponentProduct = function (planCov, loBusiness, groupNo, memberType) {
                var checkOneMedical = function(coverages) {
                    var count = 0;
                    if(Object.keys(coverages).length > 1) {
                        Object.keys(coverages).forEach(function (cove) {
                            if (coverageBuddy.coverageTypeMap.medical.indexOf(cove) > -1) {
                                count = count + 1;
                            }
                        });
                    }
                    return count > 0 ? true : false;

                };
                if (sessionData.employerInfo.brandName === '6012' || sessionData.employerInfo.brandName === '9017'|| sessionData.employerInfo.brandName === '9018') {
				
					if (planCov instanceof Object && Object.keys(planCov).length > 1) {
						
                        if (checkOneMedical(planCov)) {
                            if (coverageBuddy.coverageTypeMap.medical.indexOf(loBusiness) > -1 && !$scope.isParentChecked(groupNo, loBusiness)) {
								
								return false;
                            }
                            else if ($scope.isMemberSubscriber(memberType) && coverageBuddy.coverageTypeMap.medical.indexOf(loBusiness) > -1 && $scope.isParentChecked(groupNo, loBusiness)) {
								
								return false;
                            }
                            else if (!$scope.isMemberSubscriber(memberType) && coverageBuddy.coverageTypeMap.medical.indexOf(loBusiness) > -1 && !$scope.isParentChecked(groupNo, loBusiness)) {
							
								return false;
                            }
                            else {
								
								if((coverageBuddy.coverageTypeMap.dental.indexOf(loBusiness) > -1 || coverageBuddy.coverageTypeMap.drug.indexOf(loBusiness) > -1 ) && ( sessionData.employerInfo.brandName === '9017'|| sessionData.employerInfo.brandName === '9018'))
								{
								
									if(!$scope.isMemberSubscriber(memberType) && $scope.isParentChecked(groupNo, loBusiness))
									{
										
										return true;
									}else
									{
										
										return false;
									}
									
								} 
								else
								{
									
									return true;
								}
                                
                            }
                        }
                        else {
                            return false;
                        }

                    }
                    else {
                        return false;
                    }
                }
                else {					
                    return (!$scope.isMemberSubscriber(memberType) && $scope.isParentChecked(groupNo, loBusiness));
                }
            };

            function truncateToDay(date) {
                date.setHours(0);
                date.setMinutes(0);
                date.setSeconds(0);
                date.setMilliseconds(0);
                return date;
            }
            function getWarningMessage(p){
                $scope.futureCancelledDates = [];
                $scope.futureCancelledGroups = [];
                p.forEach(function(active) {
                    var p1 = services.eprsvc.additionalGroupInformation().getEffectiveDate(active);
                    services.eprsvc.additionalGroupInformation({ groupNumber: active }).fetch(p1).then(
                        function(response) {
                            if(response && response.data && response.data.payload && response.data.payload.cancelDate){
                                var cancelDt = new Date(response.data.payload.cancelDate);

                                var today = new Date();
                                if(truncateToDay(cancelDt) >= truncateToDay(today)){
                                    $scope.futureCancelledDates.push(response.data.payload.cancelDate);
                                    $scope.futureCancelledGroups.push(active);

                                }
                            }
                        });
                });

            }

			/**
			* Checks validity of page before submitting cancellation.
				*/
				$scope.isFormValid = function() {

					coremetrics.pageviewTag('EMPLOYERS:ENROLLMENT:CANCEL COVERAGE','EMPLOYERS:ENROLLMENT');
					var validity = $scope.cancelDate instanceof Date && $scope.cancelReason !== null;
                    if($scope.hasSEP && $scope.outSideOpen){
                        if(!isValid($scope.cancellationForm)){
                            return;
                        }

                    }

                    else{
                        if(!$scope.cancellationForm.$valid || !validity) {
                            showGenericModal({
                                                 header: 'Submission Error',
                                                 message: 'Please check that the Cancel Date and Cancel Reason are correctly set.'
                                             });
                            return;
                        }
                    }

				$scope.employee.metadata.submissionInProgress = true;

				var isCancellationStaged = false;
				services.eprsvc.enrollments().fetch().then(
					function(enrollments) {
						$scope.employee.metadata.submissionInProgress = false;

						enrollments = (((enrollments || {}).data || {}).payload || {}).enrollmentsInProgress || [];
						for (var x = 0; x < enrollments.length; x++) {
							if (enrollments[x].ssn === $scope.subscriber.ssn) {
								isCancellationStaged = enrollments[x].status !== "SAVED";
								break;
							}
						}

						if (isCancellationStaged) {
							showGenericModal({
								header: 'Submission Error',
								message: 'Record has a pending transaction, cancellation cannot be submitted at this time.'
							});
						}
						else {
							submitCancellation();
						}
					},
					function(error) {
						$scope.employee.metadata.submissionInProgress = false;

						if (error.data && error.data.baseMessage && error.data.baseMessage.returnCodeDescription) {
							if (error.data.baseMessage.returnCode === 100231) {
								//If the service 404's, this return code means no enrollments can be found.
								//In this case, we continue with our cancellation submission
								submitCancellation();
							}
							else {
								showGenericModal({
									header: 'Submission Error',
									message: 'Record may have a pending transaction, cancellation cannot be submitted at this time.'
								});
							}
						}
						else {
							showGenericModal({
								header: 'Submission Error',
								message: 'We are unable to process the request right now, Please try again later.'
							});
						}
					}
				);
			};


			var submitCancellation = function() {
				$scope.employee.metadata.submissionInProgress = true;

				var payloadEmployee = angular.copy($scope.coverageSummary);
				var voidingCoverage = $scope.cancelReason === "03";
				var voidingCoverageDateError = false;
				var normalizedCancelDate = new Date($scope.cancelDate.setHours(0,0,0,0));
				var today = new Date();

				//remove already cancelled groups originally returned
				employee.goThroughAllMembersAndDo(payloadEmployee.data, function(person) {
					var markedCoverageForRemoval = [];
					for (var x = 0; x < person.memberCoverages.length; x++) {
						var coverage = person.memberCoverages[x];
						if(coverage.memberLobs.length){
                            coverage.memberLobs = coverage.memberLobs.filter(function(membLob) {
                                if(membLob.coverageEndDate){
                                    return  !(truncateToDay( new Date(membLob.coverageEndDate)) <= truncateToDay(new Date()));
                                }
                                else {
                                    return true;
                                }

                                });
                        }
						// for (var y = 0; y < coverage.memberLobs.length; y++) {
                         //
						// 	if (coverage.memberLobs[y].coverageEndDate && truncateToDay( new Date(coverage.memberLobs[y].coverageEndDate.replace(/-/g, '\/').replace(/T.+/, ''))) <= truncateToDay(new Date())) {
						// 		coverage.memberLobs.splice(y, 1);
						// 	}
						// }
						if (coverage.memberLobs.length === 0) {
							markedCoverageForRemoval.push(x);
						}
					}
					while (markedCoverageForRemoval.length > 0) {
						var removeIndex = markedCoverageForRemoval.pop();
						person.memberCoverages.splice(removeIndex, 1);
					}
				});

				for (var w = 0; w < $scope.planHeaders.length; w++) {
					var gNum = $scope.planHeaders[w];
						for (var y = 0; y < $scope.cancellationRequests.length; y++) {
							var member = $scope.cancellationRequests[y];
							for (var z = 0; z < member.plans.length; z++) {
								if (member.plans[z].groupNumber === gNum) {
									for (var cov in member.plans[z].coverages) {
										if (member.plans[z].coverages[cov]) {
											var l = $scope.categoryCodeMap[gNum][cov];
											switch (member.relationshipCode) {
												case '20': --l.subscriber;
													break;
												case '01': --l.spouse;
													break;
												case '29': --l.domesticPartner;
													break;
												default: --l.parasites;
											}
										}
										var o = $scope.categoryCodeMap[gNum][cov];
										o.coverageCategoryCode = coverageBuddy.getCoverageCategoryCode(o.subscriber, o.spouse, o.domesticPartner, o.parasites);
									}
								}
							}
						}
					}

				var possibleGroupsToRemove = {};
				Object.keys($scope.cancellationRequests[0].plans).forEach(function(plan) {
					var groupNumber = $scope.cancellationRequests[0].plans[plan].groupNumber;
					possibleGroupsToRemove[groupNumber]= { hasAnyCancellations: false };
				});

				var setLobCancellation = function(localPerson, responsePerson) {
					for (var j = 0; j < localPerson.plans.length; j++) { //loop through each person in table
						var plan = localPerson.plans[j];         //pick the plan in the next column over
						var groupNum = plan.groupNumber;    //set that plan's group number
						for (var k = 0; k < responsePerson.memberCoverages.length; k++) { //look through all coverages
							var memberCoverage = responsePerson.memberCoverages[k];
							if (memberCoverage.groupNumber === groupNum) {  //if our column on table matches their group
								for (var coverage in plan.coverages) {      //cycle through all of their potential cancel options
									for (var m = 0; m < memberCoverage.memberLobs.length; m++) {    //cycle through their LOBs
										if (memberCoverage.memberLobs[m].lineOfBusiness === coverage) {   //when we find our match..

											memberCoverage.memberLobs[m].coverageCategoryCode = (
												$scope.categoryCodeMap[groupNum] &&
												$scope.categoryCodeMap[groupNum][coverage] &&
												$scope.categoryCodeMap[groupNum][coverage].coverageCategoryCode
											) || memberCoverage.memberLobs[m].coverageCategoryCode;

											if (plan.coverages[coverage]) {                             //if coverage in plan is being cancelled
												var lob = memberCoverage.memberLobs[m];
												if (
													voidingCoverage &&
													($filter('date')(normalizedCancelDate, 'yyyy-MM-dd') !== $filter('date')(lob.coverageEffectiveDate, 'yyyy-MM-dd'))
												) {
													voidingCoverageDateError = true;
												}
												possibleGroupsToRemove[groupNum].hasAnyCancellations = true;
												lob.coverageEndDate = normalizedCancelDate;   //set cancel date
												lob.cancelReasonCode = $scope.cancelReason;    //set reason code
												if(memberCoverage.providerInformation){
													memberCoverage.providerInformation['physicianCancellationDate'] = normalizedCancelDate;
													memberCoverage.providerInformation['cancelCode'] = $scope.cancelReason;
												}
											}
										}
									}
								}
							}
						}
					}
				};

				var updateCoverageEffectiveDates = function() {
					var aggregateCancellations = (function() {
						var allPlans = angular.copy($scope.cancellationRequests).map(function(p) {
							return p.plans;
						});

						allPlans = allPlans.reduce(function(p, n) {
							return p.concat(n);
						}, []);

						allPlans = allPlans.filter(function(p) {
							return p.coverages instanceof Object && Object.keys(p.coverages).length;
						});

						allPlans.forEach(function(p) {
							var coverages = [];
							Object.keys(p.coverages).forEach(function(lineOfBusiness) {
								if (p.coverages[lineOfBusiness]) {
									coverages.push(lineOfBusiness);
								}
							});
							p.coverages = coverages;
						});

						allPlans = allPlans.filter(function(p) {
							return p.coverages.length;
						});

						var aggregate = {};

						allPlans.forEach(function(p) {
							var gn = p.groupNumber;
							if (Array.isArray(aggregate[gn])) {
								p.coverages = p.coverages.filter(function(lineOfBusiness) {
									return aggregate[gn].indexOf(lineOfBusiness) === -1;
								});
								aggregate[gn] = aggregate[gn].concat(p.coverages);
							}
							else {
								aggregate[gn] = p.coverages;
							}
						});

						return aggregate;
					}());

					var allParticipants = [payloadEmployee.data.subscriber].concat(payloadEmployee.data.dependents);

					Object.keys(aggregateCancellations).forEach(function(gn) {
						aggregateCancellations[gn].forEach(function(lineOfBusiness) {
							allParticipants.forEach(function(p) {
								for (var i = 0; i < p.memberCoverages.length; ++i) {
									if (p.memberCoverages[i].groupNumber === gn) {
										p.memberCoverages[i].memberLobs.forEach(function(lob) {
											if (
												lob.lineOfBusiness === lineOfBusiness &&
												(!lob.coverageEndDate || lob.coverageEndDate > normalizedCancelDate)
											) {
												lob.coverageEffectiveDate = normalizedCancelDate;
											}
										});
									}
								}
							});
						});
					});
				};

				(function setLobCancellations() {
					//subscriber cancellation values
					setLobCancellation($scope.cancellationRequests[0], payloadEmployee.data.subscriber);
					//dependent cancellation values
					for (var i = 1; i < $scope.cancellationRequests.length; i++) { //loop through all dependents
						var person = $scope.cancellationRequests[i];
						employee.goThroughDependentsAndDo(payloadEmployee.data, function(dep, depIndex) {
							if (person.memberType !== 'subscriber' && dep.pin === person.pin) {
								setLobCancellation(person, dep);
							}
						});
					}
					updateCoverageEffectiveDates();
				}());

				var cancellingOnGroupAfterFutureCancelDate = false;
				var futureCancelDate, groupBeingCancelledTooLate;
				//cut out any unchanged plans from array here
				for (var group in possibleGroupsToRemove) {
					if (!possibleGroupsToRemove[group].hasAnyCancellations) {
						employee.goThroughAllMembersAndDo(payloadEmployee.data, function(person) {
							for (var q = 0; q < person.memberCoverages.length; q++) {
								if (person.memberCoverages[q].groupNumber === group) {
									person.memberCoverages.splice(q, 1);
								}
							}
						});
					} else if ($scope.futureCancelDateMap[group] && !groupBeingCancelledTooLate) {
						//if a group is going to be cancelled in the future, make sure
						//we aren't setting a cancellation after that date
						futureCancelDate = new Date($scope.futureCancelDateMap[group]);
						if (futureCancelDate < normalizedCancelDate) {
							cancellingOnGroupAfterFutureCancelDate = true;
							groupBeingCancelledTooLate = angular.copy(group);
						}
					}
				}

				// if a group has no LOBs, remove it from the payload
				payloadEmployee.data.dependents.forEach(function(d) {
					d.memberCoverages = d.memberCoverages.filter(function(g) {
						return g.memberLobs && g.memberLobs.length;
					});
				});

				// if a dependent has no groups, remove it from the payload
				payloadEmployee.data.dependents = payloadEmployee.data.dependents.filter(function(d) {
					return d.memberCoverages && d.memberCoverages.length;
				});

				if (voidingCoverageDateError) {
					showGenericModal({
						header: 'Submission Error',
						message: 'You cannot use the Void termination reason unless the Product Effective Date and the Cancel Date match.'
					});
				}
				else if (cancellingOnGroupAfterFutureCancelDate) {
					var formatDate = function(d) {
						return (d.getMonth()+1) + '/' + d.getDate() + '/' + d.getFullYear();
					};
					var message = 'Please be aware that group ' + groupBeingCancelledTooLate + ' will end on ' +
						formatDate(futureCancelDate) + ', choose a date before or equal to ' +
						formatDate(futureCancelDate) + ' to cancel the coverage for this group.';

					showGenericModal({
						header: 'Submission Error',
						message: message
					});
				}
				else {
					requestCancellation(payloadEmployee);
				}
			};


			function requestCancellation(payloadEmployee) {
				if($scope.hasSEP && $scope.outSideOpen) {
                    [payloadEmployee.data.subscriber].concat(payloadEmployee.data.dependents).forEach(function (member) {
                        coverageEffectivePins.forEach(function (pin) {
                            if (pin === member.pin) {
                                member['eventCode'] = $scope.lifeEventReason.lifeEventId;
                                member['eventDate'] = normalizeOutgoingDate($scope.lifeEventDate);
                            }
                        });
                    });
                }
				var checkStatus = function() {
				    //Changes for PM78639
					return services.eprsvc.cancelCoverageStatus().putInEmp(payloadEmployee.data.subscriber.ssn);
				};
				payloadEmployee.data.globalCoverageEffectiveDate = new Date($scope.cancelDate.setHours(0,0,0,0)); //Per Sunil, temp fix for 'READ-FAILED' errored response

				employee.save(payloadEmployee, false, true).then(checkStatus).then(
					function(response) {
						var payload = response && response.data && response.data.payload || {};
						var responseGroupNumbers = Object.keys(payload);

						var anyRequestsFailed = responseGroupNumbers.some(function(gn) {
							return !payload[gn];
						});

						$scope.spendingAccountGroupNumOptions = [];
						responseGroupNumbers.forEach(function(groupNumber) {
							if (payload[groupNumber]) {
								$scope.allGroupsWithSpendingAccounts.forEach(function(gn) {
									if (gn == groupNumber) {
										var entitlements = sessionData.employerInfo.planAdministratorEntitlements.groupLevelEntitlements[gn];
										if (
											entitlements &&
											entitlements['Spending Account'] &&
											entitlements['Spending Account'] !== 'None'
										) {
											$scope.cancellationRequests[0].plans.forEach(function(plan) {
												//check if we cancelled a subscriber for this group
												if (plan.groupNumber === gn) {
													for (var prop in plan.coverages) {
														if (plan.coverages.hasOwnProperty(prop) && plan.coverages[prop]) {
															$scope.spendingAccountGroupNumOptions.push(gn);
														}
													}
												}
											});
										}
									}
								});
							}
						});
                          var brandsNoSpending = ['6012', '6011','6010' , '9013' ,'9004']

						$scope.selectedSAGN = ((brandsNoSpending.indexOf(sessionData.employerInfo.brandName) === -1) && $scope.spendingAccountGroupNumOptions.length) > 0
							? $scope.spendingAccountGroupNumOptions[0]
							: null;
						if (anyRequestsFailed) {
							setCancelModalContent("Partially Submitted", "Your transaction could not be fully processed at this time. " +
								"Please allow 48 hours for us to complete your transaction."
							);
							$scope.selectedSAGN = null;
                            showModal();
						}
						else {
							coremetrics.finishConversion('EMPLOYERS:ENROLLMENT:CANCEL COVERAGE','EMPLOYERS:ENROLLMENT');
							coremetrics.pageviewTag('EMPLOYERS:ENROLLMENT:CANCEL COVERAGE','EMPLOYERS:ENROLLMENT');
							setCancelModalContent("Submitted", "Selected coverage has been successfully cancelled.");
                            showModal();
						}

					}
				).catch(showErrorModal);
			}

			$scope.goToSpendingAccount = function() {
				$scope.closeModal();
				$state.go('assistEmployees.spendingAccounts',
					{
						groupNumber: $scope.selectedSAGN,
						umi: UMI
					}
				);
			};

			$scope.closeModalAndReload = function() {
				$scope.closeModal();
				$state.go('home');
			};

			$scope.goBack = function() {
				$state.go($scope.sidebar.breadCrumb.primary.state, {});
			};

			/**
			* Checks if member type matches 'subscriber' to denote being main subscriber
			*/
			$scope.isMemberSubscriber = function(memberType) {
				return memberType === 'subscriber';
			};

			$scope.isParentChecked = function(groupNumber, key) {
				for (var plan in $scope.cancellationRequests[0].plans) {
					if ($scope.cancellationRequests[0].plans[plan].groupNumber === groupNumber) {
						return $scope.cancellationRequests[0].plans[plan].coverages[key];
					}
				}
			};


			(function init() {
				services.eprsvc.cancelReasonCodes().fetch().then(
					function (response) {
						$scope.cancellationOptions = response.data.payload.filter(function(p) {
                            return p.value !== '99';
                        });
					},
					function (error) {
						console.error('eprsvc.cancelReasonCodes().fetch() failed with:', error);
					}
				);
				$scope.asoValue = sessionData.entitlements.clientQualifiers.aso; //needed for date validator
				$scope.employee = employee; //needed for date validator, should refactor that directive to use isolate scope
				employee.loadSummary(UMI).then(
					function(employee) {
						if (employee && !employee.failed) {

							$scope.coverageSummary = employee;
							$scope.subscriber = employee.data.subscriber;
							$scope.dependents = employee.data.dependents;
							$scope.allGroupsWithSpendingAccounts = [];
							$scope.spendingAccountGroupNumOptions = [];
							$scope.selectedSAGN = null;
							$scope.cancelReason = null;
							$scope.futureCancelDateMap = {};


							(function checkAdditionalGroupInfo() {
								for (var index = 0; index < $scope.subscriber.memberCoverages.length; index++) {
									var groupNumber = $scope.subscriber.memberCoverages[index].groupNumber;
									(function(groupNumber) {
										services.eprsvc.additionalGroupInformation({ groupNumber: groupNumber }).fetch(services.eprsvc.additionalGroupInformation().getEffectiveDate(groupNumber)).then(
											function(response) {
												if (
													response &&
													response.data &&
													response.data.payload &&
													response.data.payload.spendingAccount
												) {
													$scope.allGroupsWithSpendingAccounts.push(groupNumber);
												}
												if (
													response &&
													response.data &&
													response.data.payload &&
													response.data.payload.cancelDate
												) {
													$scope.futureCancelDateMap[groupNumber] = response.data.payload.cancelDate;
												}
											},
											function() {
												//TODO: if we somehow get here, we should probably just blow the whole page up, since
												//we can't determine if any cancellations set are allowed or not.
											}
										);
									}(groupNumber));
								}
							}());

							$scope.initializeCancelObject(false);

							(function setBreadCrumbs() {
								var current = {
									title: 'Cancel Coverage',
									state: 'employee.cancelCoverage'
								};
								var previous = {};
								if ($state.previous.name === 'employee.details') {
									previous.title = $scope.subscriber.fullName.first + ' ' + $scope.subscriber.fullName.last;
									previous.state = 'employee.details';
								}
								else {
									previous.title = 'Find Employee';
									previous.state = 'employee.find';
								}

								$scope.sidebar.breadCrumb = {
									primary: previous,
									secondary: current
								};
							}());
						}
					}
				);
			}());
		}
	]);
};
